import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_MARITAL,
  DELETE_MARITAL,
  UPDATE_MARITAL,
  ADD_NEW_MARITAL,
} from "./actionType";

import {
  getMaritalSuccess,
  getMaritalFail,
  deleteMaritalSuccess,
  deleteMaritalFail,
  updateMaritalSuccess,
  updateMaritalFail,
  addMaritalSuccess,
  addMaritalFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getMaritalApi,
  updateMaritalApi,
  deleteMaritalApi,
  addNewMaritalApi
} from "../../helpers/backend_helper";

function* getMarital({ payload: marital }) {
  try {
    const response = yield call(getMaritalApi, marital);
    yield put(getMaritalSuccess(GET_MARITAL, response.data));
  } catch (error) {
    yield put(getMaritalFail(GET_MARITAL, error));
  }
}

function* onUpdateMarital({ payload: marital }) {
  try {
    const response = yield call(updateMaritalApi, marital);
    yield put(updateMaritalSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateMaritalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteMarital({ payload: marital }) {
  try {
    const response = yield call(deleteMaritalApi, marital);
    yield put(deleteMaritalSuccess({ marital, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteMaritalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewMarital({ payload: marital }) {
  try {
    const response = yield call(addNewMaritalApi, marital);
    yield put(addMaritalSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addMaritalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetMarital() {
  yield takeEvery(GET_MARITAL, getMarital);
}

export function* watchUpdateMarital() {
  yield takeEvery(UPDATE_MARITAL, onUpdateMarital);
}

export function* watchDeleteMarital() {
  yield takeEvery(DELETE_MARITAL, onDeleteMarital);
}

export function* watchAddNewMarital() {
  yield takeEvery(ADD_NEW_MARITAL, onAddNewMarital);
}

function* maritalSaga() {
  yield all([
    fork(watchGetMarital),
    fork(watchDeleteMarital),
    fork(watchUpdateMarital),
    fork(watchAddNewMarital)
  ]);
}

export default maritalSaga;
